import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/models/role.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-role-edit',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <app-form-role 
              (roleData)="updateRole($event)" 
              [role]="role"
            ></app-form-role> 
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class RoleEditComponent implements OnInit {
    role: Role | null = null;

    currentView = 'roles';
    
    constructor(
      private store: SettlementsService,
      private toastr: ToastrService,
      private router: Router,
      private activateRoute: ActivatedRoute,
      private breadcrumbService: BreadcrumbService,
      public authService: AuthService
    ) {}

    ngOnInit(): void {
      const ctl = this;
      this.activateRoute.params.subscribe(params => {
        this.store.getRole(params['id']).subscribe({
          next: (res: any) => {
            console.log("GET ROLE", res);
            ctl.role = res;
            this.breadcrumbService.set('@roleEdit', res.name);
          },
          error: (err: any) => {
            console.log(err);
            this.toastr.error('Ocurrió un error al obtener el rol.', 'Error');
          }
        });
      });
    }

    updateRole(event: any) {
      console.log("updateRole ", event);

      this.store.updateRole(this.role!.id, event).subscribe({
        next: (res: any) => {
          this.toastr.success('El rol se actualizó correctamente.', 'Actualizado');
          this.router.navigate(['/roles']);
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al actualizar el rol.', 'Error');
        }
      });
    }


}
